import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent implements OnInit {


  menu = [

    {
      name: "Dashboard",
      route: "/pages/Dashboard",
      status: true,
    },
    {
      name: "System Dashboard",
      route: "/pages/system_dashboard",
      status: false,
    },
    {
      name: "Manage units",
      status: false,
      route: "/pages/mange_units"
    },
    {
      name: "Manage Clients",
      status: false,
      route: "/pages/all_clients" 
    },
    {
      name: "Family Requests",
      status: false,
      route: "/pages/family_requests" 
    },
    {
      name: "Manage Villages",
      status: false,
      route: "/pages/mange_village"
      
    },
    {
      name: "Mange services",
      status: false,
      route: "/pages/all_services"
    },
    {
      name: "Services request",
      status: false,
      route: "/pages/service_request"
    },
    {
      name: "General access",
      status: false,
      route: "/pages/genral_accsess"
    },
    {
      name: "Utility",
      status: false,
      route: "/pages/Utility"
    },

    // {
    //   name: "Access Logs",
    //   status: false,
    //   route: "/pages/accsess_logs"
    // },
    {
      name: "Operators",
      status: false,
      route: "/pages/Operators"
    },
 
    {
      name: " Logs",
      status: false,
      route: "/pages/all_logs"
    },
    {
      name: "Roles and permissions",
      status: false,
      route: "/pages/roles"
    },
  
    
    {
      name: "Manage gates",
      status: false,
      route: "/pages/mange_gate"
    },
  ]
  constructor(private route: Router) { }

  ngOnInit() {
    console.log(this.route.url)
    let router = localStorage.getItem('route')
    if (router && router == this.route.url) {
      this.menu.forEach((element: any) => {
        if (router == element.route) {
          element.status = true
        } else {
          if (element.child) {
            element.child.forEach((element: any) => {
              element.status = false
            });
          } else {
            element.status = false
          }
        }
      });
    }
  }

  setRoute(item: any) {
    if (item.route) {
      this.menu.forEach((element: any) => {
        if (item.route == element.route) {
          element.status = true
        } else {
          if (element.child) {
            element.child.forEach((element: any) => {
              if (item.route == element.route) {
                element.status = true
              } else {
                element.status = false
              }
            });
          } else {
            element.status = false
          }
        }
      });

      this.route.navigateByUrl(`${item.route}`)
      localStorage.setItem('route', item.route)
    }

  }
}
